import versionInfo from "../version.json";
import logger from "./logger";

const CACHE_VERSION_KEY = "app_cache_version";
const BUILD_VERSION_KEY = "app_build_version";

export const getCurrentVersion = (): string => {
  return versionInfo.version || "1.0.0";
};

export const checkCacheVersion = (): boolean => {
  const currentVersion = getCurrentVersion();
  const cachedVersion = localStorage.getItem(CACHE_VERSION_KEY);

  if (cachedVersion !== currentVersion) {
    return false;
  }

  return true;
};

export const updateCacheVersion = (): void => {
  const currentVersion = getCurrentVersion();
  localStorage.setItem(CACHE_VERSION_KEY, currentVersion);
  localStorage.setItem(BUILD_VERSION_KEY, Date.now().toString());
};

export const clearAppCache = async (): Promise<void> => {
  if ("caches" in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
  }

  if ("serviceWorker" in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(
      registrations.map((registration) => registration.unregister()),
    );
  }

  const keysToKeep = ["authUser", "language", "theme"];
  const allKeys = Object.keys(localStorage);

  allKeys.forEach((key) => {
    if (!keysToKeep.includes(key)) {
      localStorage.removeItem(key);
    }
  });

  sessionStorage.clear();
};

export const handleCacheUpdate = async (): Promise<boolean> => {
  const isValid = checkCacheVersion();

  if (!isValid) {
    try {
      await clearAppCache();
      updateCacheVersion();
      return true;
    } catch (error) {
      logger.error("Error clearing cache:", error);
      updateCacheVersion();
      return true;
    }
  }

  return false;
};

export const forceCacheRefresh = (): void => {
  clearAppCache().then(() => {
    updateCacheVersion();
    window.location.reload();
  });
};
